import { useCallback, useEffect, useRef } from "react";
import client from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { toast } from "sonner";
import { AlertTriangle, Info, BellRing } from "lucide-react";

// Surfaces broadcast alerts as pop-ups anywhere in the app. Each alert pops once
// per browser session; urgent alerts stay until dismissed.
export function AlertPopup() {
  const seen = useRef(new Set(JSON.parse(sessionStorage.getItem("alertPopSeen") || "[]")));

  const persist = () => sessionStorage.setItem("alertPopSeen", JSON.stringify([...seen.current]));

  const load = useCallback(async () => {
    let items = [];
    try {
      const { data } = await client.get("/notifications");
      items = Array.isArray(data) ? data : [];
    } catch { return; }
    items
      .filter((n) => n.type === "alert" && !n.read && !seen.current.has(n.key))
      .forEach((n) => {
        seen.current.add(n.key);
        const sev = n.alertSeverity || "info";
        const icon = sev === "urgent" ? <AlertTriangle className="h-5 w-5" /> : sev === "warning" ? <BellRing className="h-5 w-5" /> : <Info className="h-5 w-5" />;
        const opts = {
          description: n.body || undefined,
          icon,
          duration: sev === "urgent" ? Infinity : 10000,
          className: sev === "urgent" ? "border-red-300" : sev === "warning" ? "border-amber-300" : "",
          action: {
            label: "Dismiss",
            onClick: async () => { try { await client.post(`/alerts/${n.ref}/dismiss`); } catch { /* noop */ } },
          },
        };
        if (sev === "urgent") toast.error(n.title, opts);
        else if (sev === "warning") toast.warning(n.title, opts);
        else toast.info(n.title, opts);
      });
    persist();
  }, []);

  useEffect(() => { load(); }, [load]);
  usePoll(load, 20000);
  return null;
}
